import { types } from "mobx-state-tree";

export const $spinner = types
  .model({
    visible: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    toggle() {
      self.visible = !self.visible;
    },
    show() {
      self.visible = true;
    },
    hide() {
      self.visible = false;
    },
  }))
  .create();
